import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import * as orderHandler from "@/js/order/order.js";
import { REGULAR_BOTTLING, IS_STRIPE_ENABLED, orderStatus, expeditionMethods, listTerms, upsErrors, casingWines, listWineTypes, orderAdjustmentsTypes, listWineRangeAccessibility, listCurrencies, COUNTRIES } from "@/js/lists.ts";
import { ERROR_DATA } from "@/js/forms.js";
import "vue-loading-overlay/dist/vue-loading.css";
import { hasRole, isAllowedOrderWithoutPayment, isAttachToHolding, getClientAppData } from "@/js/http/auth.js";
import { getFullNameUserHtml, getFullNameUser } from "@/js/user/user.js";
import { wineNaming } from "@/js/wine/wine.js";
import { getPriceValueInUsedCurrencyForCartAndExplore, setCurrencyUsedForCartAndExplore, getSymbolCurrency, formatPrice, roundToTwoDigit } from "@/js/currency/currencies.js";
import { isSameAddress } from "@/js/address";
import { scrollTo } from "@/js/animation.js";
import { filterIntegerKey } from "@/js/events/keycodes.js";
import adressComponent from "@/components/address/Address.vue";
import WineDiscountTooltip from "@/components/products/WineDiscountTooltip.vue";
import WholesalersData from "@/components/payment/WholesalersData.vue";
import WineNaming from "@/components/products/WineNaming.vue";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import StorageTermsReference from "@/components/common/StorageTermsReference.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "UserFinalizeCart",
  components: {
    "wine-naming": WineNaming,
    adress: adressComponent,
    WineDiscountTooltip: WineDiscountTooltip,
    confirm: confirmationComponent,
    WholesalersData: WholesalersData,
    StorageTermsReference: StorageTermsReference,
    ErrorModal: ErrorModal
  },
  props: {
    baseModel: Object,
    readOnly: Boolean,
    loggedUserData: Object
  },
  data: function data() {
    return {
      clientAppData: null,
      isChangingQuantity: false,
      isFetchingShippingCosts: false,
      isCollapsed: false,
      bufferedAddresses: {
        billingAddress: null,
        deliveryAddress: null,
        isSameAddress: null
      },
      isEditingAddresses: false,
      deliveryAddressFaultedMessage: null,
      updatingOrderStatus: false,
      isProcessingPayment: false,
      quantityToggleKey: false,
      order: {
        id_order: null,
        buyer_term: null,
        items: [],
        id_user: null,
        amount_ex_vat: null,
        total_amount: null,
        status: null,
        expedition_method: 0,
        expedition_methods: {},
        delivery_address: null,
        delivery_instructions: null,
        billing_address: null,
        amount_shipping: null,
        due_date: null,
        user: null,
        stockTransferIsAskedByUser: false
      },
      imagesBroken: [],
      defaultImporter: null,
      sameAddress: true,
      user: {},
      listCountries: [],
      listStates: [],
      expedition_methods: [],
      expedition_methods_ref: expeditionMethods,
      expeditionMethods: expeditionMethods,
      errorLabels: {
        shipping: {},
        terms: "",
        user_selected: "",
        validation_comment: "",
        cgv: "",
        tastingPhoto: "",
        quantity_orders: [],
        adjustment: ""
      },
      errorMessages: {
        mandatory: "This field is required",
        cgv: {
          required: "You must accept the terms of sales, and certify you are complying with the law"
        },
        tastingPhoto: {
          required: "You must commit to take a photo of some bottles at time of tasting"
        },
        order: {
          quantity: "You don't reach the minimum per order"
        },
        shippingType: {
          required: "You must select a shipping type"
        }
      },
      mustRecalculateCharges: true,
      updateDeliveryInstructionsToken: null,
      editingDeliveryInstructions: false,
      isSetDeliveryAddressAsDefaultForUserAddress: false,
      checkboxCGV: false,
      checkboxLawCompliance: false,
      checkboxTastingPhoto: [],
      storageLocations: {
        storageLocationsList: [],
        warehouses: []
      },
      lastExpeditionMethod: null,
      initialCurrency: null,
      updateOrderCurrencyToken: null,
      editingOrderCurrency: false,
      isUpdatingOrderCurrency: false,
      adjustmentToken: null,
      dialogAdjustment: {
        isLoading: true,
        message: "",
        message_placeholder: "Do you have any wishes regarding this order?"
      },
      orderStatus: orderStatus,
      listTerms: listTerms,
      casingWines: casingWines,
      filterIntegerKey: filterIntegerKey,
      listCurrencies: listCurrencies,
      wineNaming: wineNaming,
      ERROR_DATA: ERROR_DATA,
      IS_STRIPE_ENABLED: IS_STRIPE_ENABLED
    };
  },
  computed: {
    isOrderForIndividualUs: function isOrderForIndividualUs() {
      var _this$order, _this$order2;
      return ((_this$order = this.order) === null || _this$order === void 0 || (_this$order = _this$order.delivery_address) === null || _this$order === void 0 ? void 0 : _this$order.country.iso_2) === "US" && ((_this$order2 = this.order) === null || _this$order2 === void 0 || (_this$order2 = _this$order2.user) === null || _this$order2 === void 0 ? void 0 : _this$order2.user_group) === "USER";
    },
    isGreatExport: function isGreatExport() {
      var _this$order3;
      return !((_this$order3 = this.order) !== null && _this$order3 !== void 0 && (_this$order3 = _this$order3.delivery_address) !== null && _this$order3 !== void 0 && (_this$order3 = _this$order3.country) !== null && _this$order3 !== void 0 && _this$order3.european_union_member);
    },
    isConcernedByVat: function isConcernedByVat() {
      var _this$order4;
      return ((_this$order4 = this.order) === null || _this$order4 === void 0 ? void 0 : _this$order4.amount_vat) > 0;
    },
    isInboundAvailable: function isInboundAvailable() {
      return isAttachToHolding(this.loggedUserData) && this.order.expedition_method !== expeditionMethods.CELLAR_STORAGE.id;
    },
    groupedItemsByDeparture: function groupedItemsByDeparture() {
      var _this$order5,
        _this2 = this;
      if (!this.expedition_methods.length || !((_this$order5 = this.order) !== null && _this$order5 !== void 0 && (_this$order5 = _this$order5.items) !== null && _this$order5 !== void 0 && _this$order5.length)) return [];
      return this.order.items.reduce(function (acc, x) {
        var shippingMethods = _this2.expedition_methods.filter(function (e) {
          return e.itemIds.includes(x.id_item);
        });
        var current = _objectSpread(_objectSpread({}, x), {}, {
          shippingMethods: shippingMethods
        });
        var index = acc[0].findIndex(function (i) {
          return i.some(function (ii) {
            return ii.shippingMethods.some(function (s) {
              return s.itemIds.includes(x.id_item);
            });
          });
        });
        if (index >= 0) acc[0][index] = [].concat(_toConsumableArray(acc[0][index]), [current]);else acc[0] = [].concat(_toConsumableArray(acc[0]), [[current]]);
        return acc;
      }, [[]])[0];
    },
    defaultShippingIncludedInItemsByDeparture: function defaultShippingIncludedInItemsByDeparture() {
      var _this3 = this;
      if (!this.groupedItemsByDeparture.length) return [];
      return this.groupedItemsByDeparture.reduce(function (acc, group) {
        group.forEach(function (item) {
          var warehouseId = _this3.getAnyShippingMethod(group).departureWarehouseId;
          var shippingCost = item.unitDefaultShippingCurrency * item.quantity;
          var existingWarehouse = acc.find(function (entry) {
            return entry.warehouseId === warehouseId;
          });
          if (existingWarehouse) {
            existingWarehouse.totalDefaultShippingCurrency += shippingCost;
          } else {
            acc.push({
              warehouseId: warehouseId,
              totalDefaultShippingCurrency: shippingCost
            });
          }
        });
        return acc;
      }, []);
    },
    orderHasMultipleDepartures: function orderHasMultipleDepartures() {
      var _this$groupedItemsByD;
      return ((_this$groupedItemsByD = this.groupedItemsByDeparture) === null || _this$groupedItemsByD === void 0 ? void 0 : _this$groupedItemsByD.length) > 1;
    },
    hasBlockingNetworkError: function hasBlockingNetworkError() {
      var _this$order6, _this$groupedItemsByD2;
      return !this.isFetchingShippingCosts && ((_this$order6 = this.order) === null || _this$order6 === void 0 || (_this$order6 = _this$order6.items) === null || _this$order6 === void 0 ? void 0 : _this$order6.length) > 0 && !((_this$groupedItemsByD2 = this.groupedItemsByDeparture) !== null && _this$groupedItemsByD2 !== void 0 && _this$groupedItemsByD2.length);
    },
    nbBottles: function nbBottles() {
      var _this$order$items;
      return (_this$order$items = this.order.items) === null || _this$order$items === void 0 ? void 0 : _this$order$items.reduce(function (acc, item) {
        return acc + item.quantity;
      }, 0);
    },
    hasInactiveItems: function hasInactiveItems() {
      return this.order.items.some(function (x) {
        return x.hasClosedStock || !x.wine.is_active || x.wine.deleted || x.wine.isClosedStock;
      });
    },
    itemsRequiringTastingPhoto: function itemsRequiringTastingPhoto() {
      var _this$order$items$fil, _this$order7;
      return (_this$order$items$fil = (_this$order7 = this.order) === null || _this$order7 === void 0 ? void 0 : _this$order7.items.filter(function (x) {
        return x.wine.isTastingPhotoRequired;
      })) !== null && _this$order$items$fil !== void 0 ? _this$order$items$fil : [];
    },
    isImporterPreventPayment: function isImporterPreventPayment() {
      var _this$defaultImporter;
      return +((_this$defaultImporter = this.defaultImporter) === null || _this$defaultImporter === void 0 ? void 0 : _this$defaultImporter.id) > 0 && this.defaultImporter.isPreventingPayment;
    },
    canChangeCurrency: function canChangeCurrency() {
      var _this$order8, _this$order9, _this$order10, _this$listDefaultCurr;
      return ((_this$order8 = this.order) === null || _this$order8 === void 0 || (_this$order8 = _this$order8.delivery_address) === null || _this$order8 === void 0 || (_this$order8 = _this$order8.country) === null || _this$order8 === void 0 ? void 0 : _this$order8.currency) !== null && ((_this$order9 = this.order) === null || _this$order9 === void 0 || (_this$order9 = _this$order9.delivery_address) === null || _this$order9 === void 0 || (_this$order9 = _this$order9.country) === null || _this$order9 === void 0 ? void 0 : _this$order9.currency) !== "EUR" && ((_this$order10 = this.order) === null || _this$order10 === void 0 || (_this$order10 = _this$order10.delivery_address) === null || _this$order10 === void 0 || (_this$order10 = _this$order10.country) === null || _this$order10 === void 0 ? void 0 : _this$order10.id_country) !== COUNTRIES.USA.id && ((_this$listDefaultCurr = this.listDefaultCurrencies) === null || _this$listDefaultCurr === void 0 ? void 0 : _this$listDefaultCurr.length) > 1;
    },
    listDefaultCurrencies: function listDefaultCurrencies() {
      var _this$order$delivery_,
        _this$order$delivery_2,
        _this$order$factoring,
        _this4 = this;
      var availableCurrencies = [];
      if (((_this$order$delivery_ = this.order.delivery_address) === null || _this$order$delivery_ === void 0 || (_this$order$delivery_ = _this$order$delivery_.country) === null || _this$order$delivery_ === void 0 ? void 0 : _this$order$delivery_.id_country) === COUNTRIES.USA.id) {
        availableCurrencies = ["USD"];
      } else if (((_this$order$delivery_2 = this.order.delivery_address) === null || _this$order$delivery_2 === void 0 || (_this$order$delivery_2 = _this$order$delivery_2.country) === null || _this$order$delivery_2 === void 0 ? void 0 : _this$order$delivery_2.id_country) === COUNTRIES.BAHAMAS.id) {
        availableCurrencies = ["BSD", "USD"];
      } else {
        var _this$order11, _this$order12;
        availableCurrencies.push("EUR");
        if ((_this$order11 = this.order) !== null && _this$order11 !== void 0 && _this$order11.currency) availableCurrencies.push(this.order.currency);
        if ((_this$order12 = this.order) !== null && _this$order12 !== void 0 && (_this$order12 = _this$order12.delivery_address) !== null && _this$order12 !== void 0 && (_this$order12 = _this$order12.country) !== null && _this$order12 !== void 0 && _this$order12.currency) availableCurrencies.push(this.order.delivery_address.country.currency);
      }
      if (((_this$order$factoring = this.order.factoringProvider) === null || _this$order$factoring === void 0 || (_this$order$factoring = _this$order$factoring.currencies) === null || _this$order$factoring === void 0 ? void 0 : _this$order$factoring.length) > 0) {
        availableCurrencies = availableCurrencies.filter(function (x) {
          return _this4.order.factoringProvider.currencies.includes(x);
        });
      }
      return listCurrencies.filter(function (x) {
        return availableCurrencies.includes(x.id);
      });
    },
    hasFactoringProvider: function hasFactoringProvider() {
      var _this$order$factoring2;
      return (_this$order$factoring2 = this.order.factoringProvider) === null || _this$order$factoring2 === void 0 ? void 0 : _this$order$factoring2.id;
    }
  },
  created: function created() {
    var _this$baseModel;
    if (!((_this$baseModel = this.baseModel) !== null && _this$baseModel !== void 0 && _this$baseModel.id_order)) {
      this.$router.push({
        name: "userHome"
      });
      return;
    }
    this.clientAppData = getClientAppData(this);
    this.$EventBus.$emit("loading", true);
    this.order = _objectSpread(_objectSpread({}, this.order), this.baseModel);
    this.isSetDeliveryAddressAsDefaultForUserAddress = this.isOrderDeliveryInstructionsDefaultUser();
    var _this = this;
    this.sameAddress = isSameAddress(this.order.delivery_address, this.order.billing_address);
    if (this.sameAddress && !this.readOnly) {
      this.order.billing_address = _objectSpread({}, this.order.delivery_address);
    }
    this.getDefaultImporter();
    this.getChargesForOrder();
    request("/v1/user", "get", null, true, "api").then(function (response) {
      _this.user = _objectSpread({}, response.data);
    });
    request("/v1/countries?implantedMarket=true", "post", _this.clientAppData, false, "api").then(function (response) {
      _this.listCountries = _toConsumableArray(response.data.countries);
      _this.listStates = _toConsumableArray(response.data.states);
    }).catch(function (err) {
      _this.$toasted.show("An error occured. Please contact an administrator.", {
        type: "error"
      });
    });
    if (this.order.delivery_instructions) {
      this.inputDeliveryInstructions = this.order.delivery_instructions;
    }
    this.dispatchItemsInStorageLocations();
  },
  methods: {
    getAnyGroupedItem: function getAnyGroupedItem(groupedItems) {
      return groupedItems[0];
    },
    getAnyShippingMethod: function getAnyShippingMethod(groupedItems) {
      return this.getAnyGroupedItem(groupedItems).shippingMethods[0];
    },
    isShippingSetAvailable: function isShippingSetAvailable(groupedItems) {
      var _groupItem$shippingMe;
      var groupItem = this.getAnyGroupedItem(groupedItems);
      var expedtionMethod = groupItem.expeditionMethod;
      return !!expedtionMethod && ((_groupItem$shippingMe = groupItem.shippingMethods) === null || _groupItem$shippingMe === void 0 ? void 0 : _groupItem$shippingMe.filter(function (x) {
        return !x.isError && x.expedition_method == expedtionMethod;
      }).length) > 0;
    },
    collapse: function collapse(index) {
      this.isCollapsed = !this.isCollapsed;
      var _this = this;
      this.$nextTick(function () {
        document.querySelector("#order-summary-".concat(index)).scrollIntoView({
          behavior: "smooth",
          block: _this.isCollapsed ? "start" : "end"
        });
      });
    },
    fetchOrder: function fetchOrder(_, ack) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this = _this5;
              _context.next = 3;
              return request("/v1/order/" + _this5.order.id_order, "get", null, true, "api").catch(function (e) {
                if (e.response.data) {
                  _this.$toasted.show(e.response.data.value, {
                    type: "warning"
                  });
                }
                throw e;
              });
            case 3:
              response = _context.sent;
              _this5.order = _objectSpread(_objectSpread({}, _this5.order), response.data);
              ack(_this5.order);
              _this5.dispatchItemsInStorageLocations();
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    cancelAddresses: function cancelAddresses() {
      this.isEditingAddresses = false;
      this.mustRecalculateCharges = false;
      this.order = _objectSpread(_objectSpread({}, this.order), {}, {
        delivery_address: this.bufferedAddresses.deliveryAddress
      });
      this.order = _objectSpread(_objectSpread({}, this.order), {}, {
        billing_address: this.bufferedAddresses.billingAddress
      });
      this.sameAddress = this.bufferedAddresses.isSameAddress;
    },
    editAddresses: function editAddresses() {
      this.isEditingAddresses = true;
      this.bufferedAddresses = {
        deliveryAddress: _objectSpread({}, this.order.delivery_address),
        billingAddress: _objectSpread({}, this.order.billing_address),
        isSameAddress: this.sameAddress
      };
    },
    isActiveItem: function isActiveItem(item) {
      return !item.hasClosedStock && item.wine.is_active && !item.wine.deleted && !item.wine.isClosedStock;
    },
    productDetails: function productDetails(wine) {
      var detailsRoute = wine.type == listWineTypes.find(function (x) {
        return x.name === "Spirit";
      }).id ? "userSpiritsDetails" : "userWineDetails";
      return {
        name: detailsRoute,
        params: {
          id: wine.id_wine
        }
      };
    },
    getChargesForOrder: function getChargesForOrder() {
      this.errorLabels.quantity_orders = [];
      this.deliveryAddressFaultedMessage = null;
      this.isFetchingShippingCosts = true;
      this.$EventBus.$emit("loading", true);
      var _this = this;
      return request("/v1/order", "put", _this.order, true, "api").then(function (response) {
        return _this.confirmDeliveryAddress().then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _this.order = _objectSpread({}, response.data);
                orderHandler.setCurrentOrder(response.data);
                return _context2.abrupt("return", _this.getLogisticDetails());
              case 3:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }))).catch(function (e) {
          var _e$response;
          _this.isFetchingShippingCosts = false;
          if (e !== null && e !== void 0 && (_e$response = e.response) !== null && _e$response !== void 0 && (_e$response = _e$response.data) !== null && _e$response !== void 0 && (_e$response = _e$response.value) !== null && _e$response !== void 0 && _e$response.errorCode && upsErrors[e.response.data.value.errorCode]) {
            _this.deliveryAddressFaultedMessage = upsErrors[e.response.data.value.errorCode];
          } else {
            _this.$toasted.show("An error occured. Please contact an administrator.", {
              type: "error"
            });
          }
        });
      }).catch(function (e) {
        var _e$response2;
        _this.isFetchingShippingCosts = false;
        if (e !== null && e !== void 0 && (_e$response2 = e.response) !== null && _e$response2 !== void 0 && (_e$response2 = _e$response2.data) !== null && _e$response2 !== void 0 && (_e$response2 = _e$response2.value) !== null && _e$response2 !== void 0 && _e$response2.message) {
          var message = e.response.data.value.message;
          _this.$toasted.show(message, {
            type: "warning"
          });
        } else {
          _this.$toasted.show("An error occured. Please contact an administrator.", {
            type: "error"
          });
        }
        _this.mustRecalculateCharges = false;
        _this.order.items = _this.order.items.map(function (x) {
          return _objectSpread(_objectSpread({}, x), {}, {
            quantity: x.original_qty,
            casingId: x.originalCasingId
          });
        });
        _this.getLogisticDetails();
      }).then(function (_) {
        _this.$EventBus.$emit("loading", false);
      });
    },
    getLogisticDetails: function getLogisticDetails() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this = _this6;
              _context3.next = 3;
              return request("/v1/order/" + _this.order.id_order + "/logistic/", "get", null, true, "api").then(function (db) {
                _this.computeCharges(db.data);
                _this.$EventBus.$emit("update-cart");
                _this.isFetchingShippingCosts = false;
                if (_this.groupedItemsByDeparture.some(function (x) {
                  return x.some(function (y) {
                    return y.expeditionMethod === expeditionMethods.CELLAR_STORAGE.id;
                  });
                })) {
                  _this.$EventBus.$emit("loading", true);
                  request("/v1/order", "put", _this.order, true, "api").then(function (orderReponse) {
                    _this.order = _objectSpread(_objectSpread({}, _this.order), orderReponse.data);
                  }).finally(function (_) {
                    _this.$EventBus.$emit("loading", false);
                  });
                }
              }).catch(function () {
                _this.isFetchingShippingCosts = false;
                _this.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
              });
            case 3:
              return _context3.abrupt("return", _context3.sent);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    computeCharges: function computeCharges(db) {
      this.expedition_methods = this.getAvailableExpeditionMethods(db);
      this.expedition_methods = [].concat(_toConsumableArray(this.expedition_methods.filter(function (m) {
        return m.expedition_method !== 6;
      })), _toConsumableArray(this.expedition_methods.filter(function (m) {
        return m.expedition_method === 6;
      })));
      this.initShippingMethod();
      var groupedShippingMethodsByDeparture = this.expedition_methods.reduce(function (acc, x) {
        if (!acc[x.departureWarehouseId]) return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.departureWarehouseId, [x]));
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.departureWarehouseId, [].concat(_toConsumableArray(acc[x.departureWarehouseId]), [x])));
      }, {});

      // Compute order shipping amount
      var _this = this;
      Object.values(groupedShippingMethodsByDeparture).forEach(function (x) {
        var _x = _slicedToArray(x, 1),
          anyShippingMethod = _x[0];
        if (x.length === 1) {
          _this.order.expedition_methods[anyShippingMethod.departureWarehouseId] = anyShippingMethod;
        }
        _this.order.items.filter(function (e) {
          return anyShippingMethod.itemIds.includes(e.id_item);
        }).forEach(function (e) {
          if (x.length === 1) e.expeditionMethod = anyShippingMethod.expedition_method;
          if (!e.expeditionMethod) {
            var itemWithExistingShippingMethod = _this.order.items.filter(function (it) {
              return anyShippingMethod.itemIds.includes(it.id_item);
            }).find(function (it) {
              return !!it.expeditionMethod;
            });
            if (itemWithExistingShippingMethod) {
              e.expeditionMethod = itemWithExistingShippingMethod.expeditionMethod;
            }
          }
          if (!!e.expeditionMethod) {
            var shippingMethod = x.find(function (s) {
              return s.id === e.expeditionMethod;
            });
            if (shippingMethod) {
              e.totalShippingCurrency = shippingMethod.price_numeric_currency;
              e.shippingAmount = e.totalShippingCurrency / anyShippingMethod.itemIds.length;
            }
          }
        });
      });
      var shippingAmount = this.order.items.reduce(function (acc, x) {
        return acc + x.shippingAmount || 0;
      }, 0);
      var totalAmountCurrency = shippingAmount + this.order.items.reduce(function (acc, x) {
        return acc + x.unit_price_currency * x.quantity;
      }, 0);
      this.order = _objectSpread(_objectSpread({}, this.order), {}, {
        amount_shipping_currency: shippingAmount,
        total_amount_currency: totalAmountCurrency,
        total_amount_currency_include_credit_notes: totalAmountCurrency - this.order.credit_notes_amount_currency
      });
      this.mustRecalculateCharges = false;
    },
    initShippingMethod: function initShippingMethod() {
      var _this7 = this;
      if (this.expedition_methods.length === 1 && !this.expedition_methods[0].isError) {
        var _this$expedition_meth = this.expedition_methods[0],
          eta_min_hours = _this$expedition_meth.eta_min_hours,
          eta_max_hours = _this$expedition_meth.eta_max_hours,
          expedition_method = _this$expedition_meth.expedition_method;
        this.order.expedition_method = expedition_method;
        this.order.items.forEach(function (x) {
          return x.expeditionMethod = expedition_method;
        });
        this.order.eta_min_hours = eta_min_hours;
        this.order.eta_max_hours = eta_max_hours;
        if (this.order.expedition_method === expeditionMethods.CELLAR_STORAGE.id) {
          this.order.stockTransferIsAskedByUser = false;
        }
      }
      this.order.expedition_methods = this.expedition_methods.reduce(function (acc, x) {
        var item = _this7.order.items.find(function (e) {
          return x.itemIds.includes(e.id_item);
        });
        if (item && item.expeditionMethod === x.expedition_method) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.departureWarehouseId, x));
        }
        return acc;
      }, {});
    },
    getAvailableExpeditionMethods: function getAvailableExpeditionMethods(db) {
      var _this8 = this;
      return db.expedition_prices.map(function (x) {
        if ((x === null || x === void 0 ? void 0 : x.expedition_price) >= 0) {
          var method_ref = Object.values(_this8.expedition_methods_ref).filter(function (ep) {
            return ep.id === x.expedition_method;
          })[0];
          var priceExp = x.expeditionPriceCurrency;
          return _objectSpread(_objectSpread({}, x), {}, {
            id: x.expedition_method,
            departureWarehouseId: x.departureWarehouseId,
            icon: method_ref.faIcon,
            label: method_ref.text,
            price_numeric_currency: priceExp,
            price_label: "+ ".concat(formatPrice(priceExp / x.itemIds.length), " ").concat(_this8.getSymbolCurrency(_this8.order.currency), " / bottle"),
            price_global_label: formatPrice(priceExp) + " " + _this8.getSymbolCurrency(_this8.order.currency),
            eta_label: _this8.getEtaLabel(x.eta_min_hours, x.eta_max_hours),
            original_object: x
          });
        }
      });
    },
    getEtaLabel: function getEtaLabel(eta_min_hours, eta_max_hours) {
      var unit = eta_min_hours > 72 || eta_max_hours && eta_max_hours > 72 ? "days" : "hours";
      if (unit === "days") {
        return Math.ceil(eta_min_hours / 24) + (eta_max_hours ? "-" + Math.ceil(eta_max_hours / 24) : "") + " " + unit;
      } else {
        return eta_min_hours + (eta_max_hours ? "-" + eta_max_hours : "") + " " + unit;
      }
    },
    deleteItem: function deleteItem(itemId) {
      var _this9 = this;
      this.errorLabels.quantity_orders = [];
      this.$refs.confirm.open("Delete", "Are you sure you want to delete this product ?", {
        color: "red"
      }).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(confirm) {
          var item, _this10;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                if (!confirm) {
                  _context5.next = 9;
                  break;
                }
                _this9.mustRecalculateCharges = true;
                _this9.$EventBus.$emit("loading", true);
                item = _this9.order.items.find(function (x) {
                  return x.id_item === itemId;
                });
                _this9.order.items.splice(_this9.order.items.indexOf(item), 1);
                _context5.next = 7;
                return _this9.resetLogisticDetails();
              case 7:
                _this10 = _this9;
                request("/v1/order", "put", _this10.order, true, "api").then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                  var _yield$orderHandler$f, data;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!(_this10.order.items.length === 0)) {
                          _context4.next = 6;
                          break;
                        }
                        _context4.next = 3;
                        return _this10.emptyBasket();
                      case 3:
                        _this10.$EventBus.$emit("BasketRemoved", true);
                        _context4.next = 16;
                        break;
                      case 6:
                        _context4.next = 8;
                        return orderHandler.fetchBasket();
                      case 8:
                        _yield$orderHandler$f = _context4.sent;
                        data = _yield$orderHandler$f.data;
                        _this10.$EventBus.$emit("ItemRemoved", {
                          detail: {
                            items: data.items
                          }
                        });
                        _this10.order = data;
                        orderHandler.setCurrentOrder(data);
                        _this10.getChargesForOrder();
                        _context4.next = 16;
                        return _this10.dispatchItemsInStorageLocations();
                      case 16:
                        if (_this10.order.items.length == 0) {
                          _this10.$EventBus.$emit("loading", false);
                        }
                      case 17:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                })));
              case 9:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    emptyBasket: function emptyBasket() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this = _this11;
              _context6.next = 3;
              return request("/v1/basket/" + _this.order.id_order, "delete", {
                orderId: _this.order.id_order
              }, true, "api").catch(function () {
                _this.$toasted.show("Unable to empty cart.", {
                  type: "error"
                });
              });
            case 3:
              orderHandler.removeOrderFromStorage();
              _this11.$EventBus.$emit("BasketRemoved");
              _this11.$EventBus.$emit("ItemRemoved", {
                detail: {
                  items: []
                }
              });
              _this11.$EventBus.$emit("loading", false);
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    changeQuantityOrder: function changeQuantityOrder(item, quantity, groupedItems) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var casing, itemRef, lastExpeditionMethod, backupOrder;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this12.isChangingQuantity = true;
              casing = item.casingId.match(/\d+/)[0];
              quantity = quantity * casing;
              _this12.errorLabels.quantity_orders = [];
              _this12.$EventBus.$emit("loading", true);
              itemRef = _this12.order.items.find(function (x) {
                return x.id_item === item.id_item;
              });
              itemRef.quantity = quantity;
              itemRef.casingId = item.casingId;
              itemRef.total_amount = item.quantity * item.unit_price;
              lastExpeditionMethod = _objectSpread({}, _this12.expedition_methods.find(function (x) {
                return x.id === item.expeditionMethod;
              }));
              backupOrder = _objectSpread({}, _this12.order);
              backupOrder = _objectSpread(_objectSpread({}, backupOrder), {}, {
                items: _toConsumableArray(backupOrder.items)
              });
              _context7.prev = 12;
              _context7.next = 15;
              return _this12.resetLogisticDetails();
            case 15:
              if (itemRef.quantity == 0) {
                // if the quantity of the item is down to 0, we delete the item of the cart and from the order
                _this12.order.items.splice(_this12.order.items.indexOf(itemRef), 1);
              }
              if (!(_this12.order.items.length === 0)) {
                _context7.next = 22;
                break;
              }
              _context7.next = 19;
              return _this12.emptyBasket();
            case 19:
              _this12.$EventBus.$emit("BasketRemoved", true);
              _this12.isChangingQuantity = false;
              return _context7.abrupt("return");
            case 22:
              _this12.mustRecalculateCharges = true;
              _this12.order.items.filter(function (x) {
                return groupedItems.map(function (gi) {
                  return gi.id_item;
                }).includes(x.id_item);
              }).forEach(function (x) {
                _this12.order.items.splice(_this12.order.items.indexOf(x), 1, _objectSpread(_objectSpread({}, x), {}, {
                  expeditionMethod: lastExpeditionMethod.id
                }));
              });
              _context7.next = 26;
              return _this12.getChargesForOrder();
            case 26:
              _context7.next = 35;
              break;
            case 28:
              _context7.prev = 28;
              _context7.t0 = _context7["catch"](12);
              _this12.order = _objectSpread({}, backupOrder);
              _this12.order.items = _this12.order.items.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  quantity: x.original_qty,
                  casingId: x.originalCasingId
                });
              });
              _context7.next = 34;
              return _this12.getLogisticDetails();
            case 34:
              _this12.$EventBus.$emit("loading", false);
            case 35:
              _this12.isChangingQuantity = false;
            case 36:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[12, 28]]);
      }))();
    },
    casingsAvailable: function casingsAvailable(item) {
      var wineCasings = item.wine.casings.map(function (wc) {
        return _objectSpread(_objectSpread({}, wc), {}, {
          textCard: casingWines.find(function (x) {
            return x.value == wc.casingId;
          }).textCard
        });
      });
      wineCasings.sort(function (a, b) {
        return a.quantity - b.quantity;
      });
      return wineCasings;
    },
    updateDeliveryInstructions: function updateDeliveryInstructions() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this13$updateDeliver;
        var path, data;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              (_this13$updateDeliver = _this13.updateDeliveryInstructionsToken) === null || _this13$updateDeliver === void 0 || _this13$updateDeliver.cancel();
              _this13.updateDeliveryInstructionsToken = axios.CancelToken.source();
              path = "/v1/orders/" + _this13.order.id_order + "/delivery-instructions";
              data = {
                DeliveryInstructions: _this13.order.delivery_instructions,
                isSetAsDefaultForUserAddress: _this13.isSetDeliveryAddressAsDefaultForUserAddress
              };
              _context8.next = 6;
              return request(path, "put", data, true, "api", null, _this13.updateDeliveryInstructionsToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to update delivery instructions.", {
                    type: "error"
                  });
                  return;
                }
              });
            case 6:
              _this13.editingDeliveryInstructions = false;
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    isOrderDeliveryInstructionsDefaultUser: function isOrderDeliveryInstructionsDefaultUser() {
      return String.isNullOrEmpty(this.order.delivery_instructions) && String.isNullOrEmpty(this.order.delivery_address.deliveryInstructions) || this.order.delivery_instructions === this.order.delivery_address.deliveryInstructions;
    },
    ungrantedAccessItems: function ungrantedAccessItems() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this = _this14;
              if (!hasRole(process.env.VUE_APP_ROLES_BYPASS_RANGE_ACCESSIBILITY)) {
                _context9.next = 3;
                break;
              }
              return _context9.abrupt("return", false);
            case 3:
              _context9.next = 5;
              return request("/v1/category-users/".concat(_this14.user.id_user, "/ungranted-access-items/").concat(_this14.order.id_order), "get", null, true, "api", null).catch(function (e) {
                var _e$response3;
                var _e$response$data = e === null || e === void 0 || (_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : _e$response3.data,
                  value = _e$response$data.value;
                if (value) {
                  _this.$toasted.show(value.errorMessage, {
                    type: "warning"
                  });
                }
                throw e;
              });
            case 5:
              response = _context9.sent;
              if (!((response === null || response === void 0 ? void 0 : response.data.value.length) > 0)) {
                _context9.next = 9;
                break;
              }
              response.data.value.forEach(function (itemId) {
                var item = _this.order.items.find(function (x) {
                  return x.id_item == itemId;
                });
                _this.$toasted.show("".concat(item.wine.display_name, " ").concat(listWineRangeAccessibility.find(function (z) {
                  return z.id == item.wine.rangeAccessibility;
                }).textForProductFilters), {
                  type: "warning"
                });
              });
              return _context9.abrupt("return", true);
            case 9:
              return _context9.abrupt("return", false);
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    continueToPayment: function continueToPayment() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this16;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!_this15.order.items.some(function (x) {
                return !_this15.isActiveItem(x);
              })) {
                _context10.next = 2;
                break;
              }
              return _context10.abrupt("return");
            case 2:
              _context10.next = 4;
              return _this15.ungrantedAccessItems();
            case 4:
              if (!_context10.sent) {
                _context10.next = 6;
                break;
              }
              return _context10.abrupt("return");
            case 6:
              if (_this15.sameAddress) {
                _this15.order.billing_address = _this15.order.delivery_address;
              }
              if (!_this15.checkInputsPayment()) {
                _context10.next = 13;
                break;
              }
              _this15.saveAdjustment();
              _this15.isProcessingPayment = true;
              _this16 = _this15;
              _context10.next = 13;
              return request("/v1/order", "put", _this15.order, true, "api").then(function (response) {
                _this16.isProcessingPayment = false;
                orderHandler.setCurrentOrder(response.data);
                orderHandler.setCurrentPayment(response.data);
                _this16.$router.push({
                  name: "orderPayment"
                });
              });
            case 13:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    userValidateOrderWithoutPayment: function userValidateOrderWithoutPayment() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var response, _this18;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (!_this17.order.items.some(function (x) {
                return !_this17.isActiveItem(x);
              })) {
                _context11.next = 2;
                break;
              }
              return _context11.abrupt("return");
            case 2:
              _context11.next = 4;
              return _this17.ungrantedAccessItems();
            case 4:
              if (!_context11.sent) {
                _context11.next = 6;
                break;
              }
              return _context11.abrupt("return");
            case 6:
              if (_this17.sameAddress) {
                _this17.order.billing_address = _this17.order.delivery_address;
              }
              if (!_this17.checkInputsPayment()) {
                _context11.next = 22;
                break;
              }
              _this17.$EventBus.$emit("loading", true);
              _this17.saveAdjustment();
              _context11.next = 12;
              return request("/v1/order", "put", _this17.order, true, "api");
            case 12:
              response = _context11.sent;
              _this17.order = response.data;
              _this18 = _this17;
              _this17.updatingOrderStatus = true;
              _context11.next = 18;
              return request("/v1/order/" + _this18.order.id_order + "/state/" + _this17.orderStatus.find(function (x) {
                return x.id == "AWAITING_VALIDATION";
              }).status, "put", {}, true, "api").catch(function () {
                _this18.updatingOrderStatus = false;
                _this18.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
              });
            case 18:
              _this17.updatingOrderStatus = false;
              orderHandler.removeOrderFromStorage();
              _this17.$EventBus.$emit("loading", false);
              _this17.$router.push({
                name: "orderPayment",
                params: {
                  orderValidated: true
                }
              });
            case 22:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    changeExpeditionMethod: function changeExpeditionMethod(shipItem, groupedItems) {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _lastExpeditionMethod, _lastExpeditionMethod2;
        var lastExpeditionMethods, _lastExpeditionMethod3, isDeselectingCellar, confirmed, _this20;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this19.errorLabels.quantity_orders = [];
              _this19.errorLabels.shipping = {};
              if (!_this19.order.expedition_methods) _this19.order.expedition_methods = {};
              lastExpeditionMethods = _objectSpread({}, _this19.order.expedition_methods);
              if (!((shipItem.expedition_method === expeditionMethods.CELLAR_STORAGE.id || ((_lastExpeditionMethod = lastExpeditionMethods[shipItem.departureWarehouseId]) === null || _lastExpeditionMethod === void 0 ? void 0 : _lastExpeditionMethod.id) === expeditionMethods.CELLAR_STORAGE.id) && shipItem.expedition_method !== ((_lastExpeditionMethod2 = lastExpeditionMethods[shipItem.departureWarehouseId]) === null || _lastExpeditionMethod2 === void 0 ? void 0 : _lastExpeditionMethod2.id))) {
                _context12.next = 23;
                break;
              }
              isDeselectingCellar = ((_lastExpeditionMethod3 = lastExpeditionMethods[shipItem.departureWarehouseId]) === null || _lastExpeditionMethod3 === void 0 ? void 0 : _lastExpeditionMethod3.id) === expeditionMethods.CELLAR_STORAGE.id;
              _context12.next = 8;
              return _this19.$refs.confirm.open("To your attention", isDeselectingCellar ? "When deselecting this type of shipment, be aware that duties and taxes will be included in the products. Wine's prices will be update." : "When choosing the type of shipment « stored at the cellar », please be aware that duties and taxes will no longer be included on the products and may be charged to you later by the financial authorities. Wine prices will be updated.", {
                color: "warning"
              });
            case 8:
              confirmed = _context12.sent;
              if (!confirmed) {
                _context12.next = 19;
                break;
              }
              _this19.$EventBus.$emit("loading", true);
              if (!_this19.orderHasMultipleDepartures) {
                _this19.order.expedition_method = shipItem.expedition_method;
                _this19.order.eta_min_hours = shipItem.eta_min_hours;
                _this19.order.eta_max_hours = shipItem.eta_max_hours;
              }
              _this19.order.expedition_methods[shipItem.departureWarehouseId] = shipItem;
              _this19.computeShippingAmount(groupedItems, shipItem.id, shipItem.price_numeric_currency);
              if (_this19.order.expedition_method === expeditionMethods.CELLAR_STORAGE.id) {
                _this19.order.stockTransferIsAskedByUser = false;
              }
              _this20 = _this19;
              request("/v1/order", "put", _this20.order, true, "api").then(function (response) {
                _this20.$EventBus.$emit("loading", false);
                _this20.$nextTick(function () {
                  _this20.order = _objectSpread(_objectSpread({}, _this20.order), {}, {
                    expedition_methods: _objectSpread(_objectSpread({}, _this20.order.expedition_methods), {}, _defineProperty({}, shipItem.departureWarehouseId, shipItem))
                  }, response.data);
                  _this20.computeShippingAmount(groupedItems, shipItem.id, shipItem.price_numeric_currency);
                  orderHandler.setCurrentOrder(_this20.order);
                });
              });
              _context12.next = 21;
              break;
            case 19:
              _this19.order = _objectSpread(_objectSpread({}, _this19.order), {}, {
                expedition_methods: _objectSpread({}, lastExpeditionMethods)
              });
              return _context12.abrupt("return");
            case 21:
              _context12.next = 26;
              break;
            case 23:
              if (!_this19.orderHasMultipleDepartures) {
                _this19.order.expedition_method = shipItem.expedition_method;
                _this19.order.eta_min_hours = shipItem.eta_min_hours;
                _this19.order.eta_max_hours = shipItem.eta_max_hours;
              }
              _this19.order.expedition_methods[shipItem.departureWarehouseId] = shipItem;
              _this19.computeShippingAmount(groupedItems, shipItem.id, shipItem.price_numeric_currency);
            case 26:
              orderHandler.setCurrentOrder(_this19.order);
              _this19.$nextTick(function () {
                _this19.order.expedition_methods = _objectSpread(_objectSpread({}, _this19.order.expedition_methods), {}, _defineProperty({}, shipItem.departureWarehouseId, shipItem));
              });
            case 28:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    computeShippingAmount: function computeShippingAmount(groupedItems, shippingMethod, totalShippingCurrency) {
      var _this21 = this;
      var _iterator = _createForOfIteratorHelper(groupedItems),
        _step;
      try {
        var _loop = function _loop() {
          var groupedItem = _step.value;
          var item = _this21.order.items.find(function (i) {
            return i.id_item === groupedItem.id_item;
          });
          var index = _this21.order.items.indexOf(item);
          _this21.order.items.splice(index, 1, _objectSpread(_objectSpread({}, item), {}, {
            expeditionMethod: shippingMethod,
            totalShippingCurrency: totalShippingCurrency
          }));
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (!this.orderHasMultipleDepartures) {
        var shippingAmount = this.groupedItemsByDeparture.reduce(function (acc, x, i) {
          var _x$;
          if (i === _this21.groupedItemsByDeparture.indexOf(groupedItems)) return acc;
          return acc + (((_x$ = x[0]) === null || _x$ === void 0 ? void 0 : _x$.totalShippingCurrency) || 0);
        }, 0);
        var totalAmountCurrency = shippingAmount + this.order.items.reduce(function (acc, x) {
          return acc + x.unit_price_currency * x.quantity;
        }, 0);
        this.order = _objectSpread(_objectSpread({}, this.order), {}, {
          amount_shipping_currency: shippingAmount,
          total_amount_currency: totalAmountCurrency,
          total_amount_currency_include_credit_notes: totalAmountCurrency - this.order.credit_notes_amount_currency
        });
      }
    },
    resetLogisticDetails: function resetLogisticDetails() {
      var _this22 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this, path;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this = _this22;
              _context13.prev = 1;
              _this22.order.expedition_methods = [];
              _this22.order.expedition_method = 0;
              _this22.order.eta_min_hours = 0;
              _this22.order.eta_max_hours = null;
              _this22.order.amount_shipping_currency = null;
              _this22.order.items = _this22.order.items.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  expeditionMethod: null
                });
              });
              path = "/v1/orders/".concat(_this22.order.id_order, "/logistic-details/");
              _context13.next = 11;
              return request(path, "delete", {}, true, "api");
            case 11:
              _context13.next = 16;
              break;
            case 13:
              _context13.prev = 13;
              _context13.t0 = _context13["catch"](1);
              _this.$toasted.show("An error occured. Please contact an administrator.", {
                type: "error"
              });
            case 16:
            case "end":
              return _context13.stop();
          }
        }, _callee13, null, [[1, 13]]);
      }))();
    },
    confirmDeliveryAddress: function confirmDeliveryAddress() {
      // const _this = this

      return Promise.resolve();

      // !!! Temporary
      // return refreshToken(this).then(function () {
      //   return request(
      //     "/v1/order/" + _this.order.id_order + "/delivery_address/approval",
      //     "post",
      //     {},
      //     true,
      //     "api"
      //   )
      // })
    },
    saveAddress: function saveAddress() {
      this.getChargesForOrder();
      //this.getDefaultImporter()
      this.isEditingAddresses = false;
    },
    addressChange: function addressChange() {
      if (this.sameAddress) {
        this.order.billing_address = _objectSpread({}, this.order.delivery_address);
      }
      orderHandler.setCurrentOrder(this.order);
      this.mustRecalculateCharges = true;
    },
    getDefaultImporter: function getDefaultImporter() {
      var _this23 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var path, response;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              path = "/v1/order/".concat(_this23.order.id_order, "/default-importer");
              _context14.next = 3;
              return request(path, "get", null, true, "api").catch(function (e) {
                throw e;
              });
            case 3:
              response = _context14.sent;
              _this23.defaultImporter = response.data;
            case 5:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    saveAdjustment: function saveAdjustment() {
      var _this24 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var _this25, _this25$adjustmentTok;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!_this24.dialogAdjustment.message) {
                _context15.next = 12;
                break;
              }
              _this25 = _this24;
              _context15.prev = 2;
              (_this25$adjustmentTok = _this25.adjustmentToken) === null || _this25$adjustmentTok === void 0 || _this25$adjustmentTok.cancel();
              _this25.adjustmentToken = axios.CancelToken.source();
              _context15.next = 7;
              return request("/v1/orders/adjustments", "post", {
                order_id: _this25.order.id_order,
                type: orderAdjustmentsTypes.USER_ASK_ADJUSTMENT.id,
                custom_message: _this25.dialogAdjustment.message
              }, true, "api", null, _this25.adjustmentToken);
            case 7:
              _context15.next = 12;
              break;
            case 9:
              _context15.prev = 9;
              _context15.t0 = _context15["catch"](2);
              if (!axios.isCancel(_context15.t0)) {
                _this25.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
              }
            case 12:
            case "end":
              return _context15.stop();
          }
        }, _callee15, null, [[2, 9]]);
      }))();
    },
    checkInputs: function checkInputs() {
      var _this26 = this,
        _this$itemsRequiringT;
      var valid = true;
      this.errorLabels.shipping = {};
      var _this$groupedItemsByD3 = this.groupedItemsByDeparture.filter(function (x) {
          return x.some(function (i) {
            return !i.expeditionMethod || _this26.expedition_methods.filter(function (e) {
              return !e.isError;
            }).filter(function (e) {
              return e.itemIds.includes(i.id_item);
            }).every(function (e) {
              return i.expeditionMethod !== e.expedition_method;
            });
          });
        }),
        _this$groupedItemsByD4 = _slicedToArray(_this$groupedItemsByD3, 1),
        shippingMethods = _this$groupedItemsByD4[0];
      if (!!(shippingMethods !== null && shippingMethods !== void 0 && shippingMethods.length)) {
        this.errorLabels.shipping = shippingMethods.reduce(function (acc, x) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.shippingMethods[0].departureWarehouseId, _this26.errorMessages.shippingType.required));
        }, {});
        valid = false;
      }
      this.errorLabels.terms = "";
      this.errorLabels.cgv = "";
      this.errorLabels.tastingPhoto = "";
      if (!this.checkboxCGV || !this.checkboxLawCompliance) {
        this.errorLabels.cgv = this.errorMessages.cgv.required;
        valid = false;
      }
      if (this.order.buyer_term == null) {
        this.errorLabels.terms = this.errorMessages.mandatory;
        valid = false;
      }
      if (((_this$itemsRequiringT = this.itemsRequiringTastingPhoto) === null || _this$itemsRequiringT === void 0 ? void 0 : _this$itemsRequiringT.length) > 0) {
        var itemIdsRequiringTastingPhoto = this.itemsRequiringTastingPhoto.map(function (x) {
          return x.id_item;
        });
        if (itemIdsRequiringTastingPhoto.some(function (id) {
          return !_this26.checkboxTastingPhoto[id];
        })) {
          this.errorLabels.tastingPhoto = this.errorMessages.tastingPhoto.required;
          valid = false;
        }
      }
      if (!this.$refs.deliveryAddress.validateForm()) {
        valid = false;
      }
      if (!this.sameAddress && !this.$refs.billingAddress.validateForm()) {
        valid = false;
      }
      return valid;
    },
    checkInputsPayment: function checkInputsPayment() {
      var _this27 = this;
      var valid = this.checkInputs();
      this.errorLabels.quantity_orders = [];
      var amountCurrencyByPassVolume = getPriceValueInUsedCurrencyForCartAndExplore(+this.$whitelabel.orderLimitMinPriceWithoutShipping);
      var isMultiDeparture = this.groupedItemsByDeparture.length > 1;
      var invalidOrders = this.groupedItemsByDeparture.filter(function (g) {
        return g.reduce(function (acc, i) {
          return acc + i.quantity * i.wine.bottling;
        }, 0) < _this27.$whitelabel.orderLimitMinVolume && g.reduce(function (acc, i) {
          return acc + i.total_amount_currency - ((i === null || i === void 0 ? void 0 : i.totalShipping) || 0);
        }, 0) < amountCurrencyByPassVolume;
      });
      if (!!invalidOrders.length) {
        valid = false;
        this.errorLabels.quantity_orders = invalidOrders.map(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 1),
            x = _ref5[0];
          var _x$shippingMethods = _slicedToArray(x.shippingMethods, 1),
            shippingMethod = _x$shippingMethods[0];
          return {
            anchor: shippingMethod.id,
            text: "Minimum order quantity of " + parseInt(_this27.$whitelabel.orderLimitMinVolume / REGULAR_BOTTLING) + " bottles (" + _this27.$whitelabel.orderLimitMinVolume / 1000 + "L) or " + _this27.formatPrice(amountCurrencyByPassVolume) + " " + _this27.getSymbolCurrency(_this27.order.currency) + " of total value" + (isMultiDeparture ? " per departure" : "")
          };
        });
      }
      return valid;
    },
    openToS: function openToS() {
      var anchor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var routeData = this.$router.resolve({
        name: "userTermsOfSales",
        hash: anchor
      });
      window.open(routeData.href);
    },
    changeItemRemoved: function changeItemRemoved(event) {
      this.order.items = _toConsumableArray(event.detail.items);
      this.mustRecalculateCharges = true;
    },
    redirectToWineCatalog: function redirectToWineCatalog() {
      var _this$$route;
      if (((_this$$route = this.$route) === null || _this$$route === void 0 ? void 0 : _this$$route.name) !== "userProductList") {
        this.$router.push({
          name: "userProductList"
        });
      }
    },
    startEditOrderCurrency: function startEditOrderCurrency() {
      var _this28 = this;
      this.editingOrderCurrency = true;
      this.initialCurrency = this.order.currency;
      this.$nextTick(function (_) {
        _this28.$refs.inputOrderCurrency.focus();
      });
    },
    updateOrderCurrency: function updateOrderCurrency() {
      var _this29 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var _this29$updateOrderCu;
        var _this;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _this29.isUpdatingOrderCurrency = true;
              (_this29$updateOrderCu = _this29.updateOrderCurrencyToken) === null || _this29$updateOrderCu === void 0 || _this29$updateOrderCu.cancel();
              _this29.updateOrderCurrencyToken = axios.CancelToken.source();
              _this = _this29;
              _context16.next = 6;
              return request("/v1/order/currency", "post", {
                orderId: _this29.order.id_order,
                currency: _this29.order.currency
              }, true, "api", null, _this29.updateOrderCurrencyToken).catch(function (e) {
                _this.isUpdatingOrderCurrency = false;
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to change the currency.", {
                    type: "error"
                  });
                  return;
                }
              });
            case 6:
              setCurrencyUsedForCartAndExplore(_this29.order.currency);
              _context16.next = 9;
              return _this29.getChargesForOrder();
            case 9:
              _this29.editingOrderCurrency = false;
              _this29.isUpdatingOrderCurrency = false;
            case 11:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    startEditDeliveryInstructions: function startEditDeliveryInstructions() {
      var _this30 = this;
      this.editingDeliveryInstructions = true;
      this.$nextTick(function (_) {
        _this30.$refs.inputDeliveryInstruction.focus();
      });
    },
    dispatchItemsInStorageLocations: function dispatchItemsInStorageLocations() {
      this.storageLocations = {
        storageLocationsList: [],
        warehouses: []
      };
      this.storageLocations.warehouses.push({
        items: this.order.items
      });
      this.sortItemByWinery();
    },
    sortItemByWinery: function sortItemByWinery() {
      var _this31 = this;
      this.storageLocations.warehouses.forEach(function (x, i) {
        _this31.storageLocations.warehouses[i].items.sort(function (a, b) {
          if (a.wine.producer.name < b.wine.producer.name) return -1;
          if (a.wine.producer.name > b.wine.producer.name) return 1;
          return 0;
        });
      });
    },
    getDefaultShippingCurrencyIncludedByDeparture: function getDefaultShippingCurrencyIncludedByDeparture(departureWarehouseId) {
      var shippingChosen = this.getShippingChosenForDeparture(departureWarehouseId);
      if ((shippingChosen === null || shippingChosen === void 0 ? void 0 : shippingChosen.expedition_method) === expeditionMethods.CELLAR_STORAGE.id) {
        return 0;
      } else {
        var _this$defaultShipping, _this$defaultShipping2;
        return roundToTwoDigit((_this$defaultShipping = (_this$defaultShipping2 = this.defaultShippingIncludedInItemsByDeparture) === null || _this$defaultShipping2 === void 0 || (_this$defaultShipping2 = _this$defaultShipping2.find(function (x) {
          return x.warehouseId === departureWarehouseId;
        })) === null || _this$defaultShipping2 === void 0 ? void 0 : _this$defaultShipping2.totalDefaultShippingCurrency) !== null && _this$defaultShipping !== void 0 ? _this$defaultShipping : 0);
      }
    },
    showShippingPriceMinusDefault: function showShippingPriceMinusDefault(shipItem, groupedItems) {
      return orderHandler.showShippingPriceMinusDefault(shipItem, groupedItems, this.order.currency);
    },
    shouldShowWarningDefaultShipping: function shouldShowWarningDefaultShipping(groupedItems) {
      var defaultShippingCurrencyIncluded = this.getDefaultShippingCurrencyIncludedByDeparture(this.getAnyShippingMethod(groupedItems).departureWarehouseId);
      var shippingMethods = this.getAnyGroupedItem(groupedItems).shippingMethods;
      return !shippingMethods.some(function (x) {
        return x.expedition_method !== expeditionMethods.CELLAR_STORAGE.id && x.expeditionPriceCurrency <= defaultShippingCurrencyIncluded;
      });
    },
    getSubtotalPriceForDeparture: function getSubtotalPriceForDeparture(groupedItems) {
      var itemsPrice = groupedItems.reduce(function (acc, x) {
        return acc + x.total_amount_currency;
      }, 0);
      var exempleItem = this.getAnyGroupedItem(groupedItems);
      var departureWarehouseId = this.getAnyShippingMethod(groupedItems).departureWarehouseId;
      var shippingMethodForDeparture = exempleItem.expeditionMethod;
      var shippingPrice = 0;
      if (shippingMethodForDeparture == null) {
        shippingPrice = +this.getDefaultShippingCurrencyIncludedByDeparture(departureWarehouseId);
      } else if (shippingMethodForDeparture != this.expeditionMethods.CELLAR_STORAGE.id) {
        var _this$getShippingChos, _this$getShippingChos2;
        shippingPrice = (_this$getShippingChos = (_this$getShippingChos2 = this.getShippingChosenForDeparture(departureWarehouseId)) === null || _this$getShippingChos2 === void 0 ? void 0 : _this$getShippingChos2.expeditionPriceCurrency) !== null && _this$getShippingChos !== void 0 ? _this$getShippingChos : 0;
      }
      return roundToTwoDigit(itemsPrice + shippingPrice);
    },
    getShippingChosenForDeparture: function getShippingChosenForDeparture(departureWarehouseId) {
      var _this$order13;
      if ((_this$order13 = this.order) !== null && _this$order13 !== void 0 && _this$order13.expedition_methods) {
        var _this$order$expeditio;
        return (_this$order$expeditio = this.order.expedition_methods[departureWarehouseId]) !== null && _this$order$expeditio !== void 0 ? _this$order$expeditio : null;
      } else {
        return null;
      }
    },
    getUnitPriceCurrencyForItem: function getUnitPriceCurrencyForItem(item, groupedItems) {
      var shippingChosen = this.getShippingChosenForDeparture(this.getAnyShippingMethod(groupedItems).departureWarehouseId);
      var unitPriceCurrency = item.unitPriceIncludeDefaultShippingCurrency;
      if ((shippingChosen === null || shippingChosen === void 0 ? void 0 : shippingChosen.expedition_method) === expeditionMethods.CELLAR_STORAGE.id) {
        unitPriceCurrency = item.unit_price_currency;
      }
      return unitPriceCurrency;
    },
    getOrderTotalIncludeCreditNoteCurrency: function getOrderTotalIncludeCreditNoteCurrency() {
      var _this32 = this;
      var total = 0;
      this.groupedItemsByDeparture.forEach(function (groupedItems) {
        total += +_this32.getSubtotalPriceForDeparture(groupedItems);
      });
      return total - +this.order.credit_notes_amount_currency;
    },
    isShippingOutOfRange: function isShippingOutOfRange(groupedItems) {
      var _this$getAnyGroupedIt;
      return ((_this$getAnyGroupedIt = this.getAnyGroupedItem(groupedItems).shippingMethods) === null || _this$getAnyGroupedIt === void 0 ? void 0 : _this$getAnyGroupedIt.length) === 1 && this.getAnyGroupedItem(groupedItems).shippingMethods[0].isOutOfRange;
    },
    getShippingOutOfRangeMessage: function getShippingOutOfRangeMessage(groupedItems) {
      var nbVariation = this.getAnyGroupedItem(groupedItems).shippingMethods[0].outOfRangeVariation;
      if (nbVariation > 0) {
        return "You should add ".concat(nbVariation, " regular bottle").concat(nbVariation > 1 && "s", " to get an available shipping method");
      } else {
        return "You should remove ".concat(nbVariation, " regular bottle").concat(nbVariation > 1 && "s", " to get an available shipping method");
      }
    },
    isShippingInErrorEvenSuperAdmin: function isShippingInErrorEvenSuperAdmin(groupedItems) {
      var _this$getAnyGroupedIt2;
      return ((_this$getAnyGroupedIt2 = this.getAnyGroupedItem(groupedItems).shippingMethods) === null || _this$getAnyGroupedIt2 === void 0 ? void 0 : _this$getAnyGroupedIt2.length) === 1 && this.getAnyGroupedItem(groupedItems).shippingMethods[0].isErrorEvenSuperAdmin;
    },
    isShippingInError: function isShippingInError(groupedItems) {
      var _this$getAnyGroupedIt3;
      return ((_this$getAnyGroupedIt3 = this.getAnyGroupedItem(groupedItems).shippingMethods) === null || _this$getAnyGroupedIt3 === void 0 ? void 0 : _this$getAnyGroupedIt3.length) === 1 && this.getAnyGroupedItem(groupedItems).shippingMethods[0].isError;
    },
    getSymbolCurrency: getSymbolCurrency,
    formatPrice: formatPrice,
    getFullNameUserHtml: getFullNameUserHtml,
    getFullNameUser: getFullNameUser,
    scrollTo: scrollTo,
    isAllowedOrderWithoutPayment: isAllowedOrderWithoutPayment
  },
  mounted: function mounted() {
    var _this33 = this;
    this.$EventBus.$on("BasketRemoved", function (redirect) {
      return redirect && _this33.redirectToWineCatalog();
    });
    this.$EventBus.$on("ItemRemoved", this.changeItemRemoved);
  },
  watch: {
    "order.expedition_methods": function orderExpedition_methods(newVal, oldVal) {
      this.lastExpeditionMethod = _objectSpread({}, oldVal);
    },
    "order.status": function orderStatus(newVal, oldVal) {
      this.order.resume_status = null;
    },
    hasBlockingNetworkError: function hasBlockingNetworkError(newVal, oldVal) {
      if (newVal === true) {
        var buttons = [{
          text: "Return to product list",
          iconClass: "fas fa-undo",
          to: {
            name: "userProductList"
          }
        }];
        this.$refs[ERROR_DATA.ref].open(ERROR_DATA.DIALOG_TYPES.DIALOG_RELOAD.id, ERROR_DATA.DIALOG_TYPES.DIALOG_RELOAD.defaultCustomMessage, {
          hideDefaultMessage: true,
          showMessage: true
        }, null, null, buttons);
      }
    }
  }
};